<template>
  <div class="code-verification-dialog-content">
    <div class="modal-qr-v2__content code-verify-v2">
      <div class="modal-qr-v2__header">
        <h2>{{ $t("verify_code_title") }}</h2>
      </div>

      <div class="modal-qr-v2__ticket" data-test="code-verify-modal-ticket">
        <div class="modal-qr-v2__tabs" data-test="code-verify-modal-tabs">
          <button
            type="button"
            :class="[
              'modal-qr-v2__tab',
              { 'is-active': tabIndex == 2 || tabIndex == '2' }
            ]"
            data-test="code-verify-modal-qr-tab"
            @click="tabIndex = '2'"
          >
            <!-- <font-awesome-icon icon="qrcode" /> -->
            {{ $t("qr_code") }}
          </button>
          <button
            type="button"
            :class="[
              'modal-qr-v2__tab',
              { 'is-active': tabIndex == 1 || tabIndex == '1' }
            ]"
            data-test="code-verify-modal-barcode-tab"
            @click="tabIndex = '1'"
          >
            <!-- <font-awesome-icon icon="barcode" /> -->
            {{ $t("barcode") }}
          </button>
        </div>

        <div class="modal-qr-v2__code-box">
          <qrcode-vue
            v-if="tabIndex == 2 || tabIndex == '2'"
            class="modal-qr-v2__qr"
            :value="qrValue"
            render-as="svg"
            background="transparent"
            data-test="code-verify-modal-qr"
          />
          <Barcode
            v-else
            :value="qrValue"
            data-test="code-verify-modal-barcode"
          />
        </div>

        <button
          type="button"
          class="modal-qr-v2__member-code"
          data-test="code-verify-modal-copy-btn"
          @click="copyCode"
        >
          {{ $t("verify_member_code") }}
          <br />
          <strong>{{ qrValue }}</strong>
          <span
            class="copy-icon"
            :style="{ '--icon-url': `url(${$baseUrl}svg/copy.svg)` }"
            aria-hidden="true"
            data-test="code-verify-modal-copy-icon"
            @click.stop="copyCode"
          ></span>
        </button>

        <!-- <div class="modal-qr-v2__timer" data-test="code-verify-modal-timer">
          <strong>{{ countTime }}</strong>
        </div> -->
      </div>

      <div class="modal-qr-v2__actions code-verify-v2__actions">
        <c-btn
          block
          variant="outline-primary"
          class="modal-qr-v2__primary-btn"
          @click="onClose"
          data-test="code-verify-modal-close-btn"
        >
          {{ $t("close") }}
        </c-btn>
      </div>
    </div>
  </div>
</template>

<script>
import Barcode from "@/components/other/Barcode.vue";
var x;
export default {
  name: "CodeVerificationDialogContent",
  components: {
    Barcode
  },
  props: {
    profile: {
      required: true,
      type: Object
    },
    refDocId: {
      type: [Number, String],
      default: 0
    },
    docType: {
      type: [Number, String],
      default: 1
    },
    isBottomSheet: { type: Boolean, default: false }
  },
  emits: ["action", "close"],
  data() {
    return {
      countTime: "00:00",
      tabIndex: this.$config.line_setting_primary_code || 2,
      payload: {
        refDocId: this.refDocId,
        docType: this.docType
      },
      qrValue: ""
    };
  },
  async mounted() {
    this.emitter.emit("showLoading");
    await this.getVerificationCode();
    this.emitter.emit("hideLoading");
  },
  beforeUnmount() {
    clearInterval(x);
  },
  methods: {
    onClose() {
      clearInterval(x);
      this.$emit("close");
    },
    countTimer() {
      function padZero(value) {
        value = String(value);
        return value.length == 1 ? "0" + value : value;
      }
      var countDownDate = this.$moment().add(10, "minute").valueOf();
      x = setInterval(() => {
        var now = this.$moment().valueOf();
        var distance = countDownDate - now;
        var minutes = padZero(
          Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
        );
        var seconds = padZero(Math.floor((distance % (1000 * 60)) / 1000));

        if (distance < 0) {
          clearInterval(x);
          return this.getVerificationCode();
        }
        this.$nextTick(() => {
          this.countTime = minutes + ":" + seconds;
        });
      }, 900);
    },
    async getVerificationCode() {
      try {
        const res = await this.$axios.post(
          "/api/v1/reward/GenVerifyQRCode",
          this.payload
        );
        this.qrValue = res.detail;
        this.countTimer();
      } catch (error) {
        this.$logger({
          response: error?.response || {
            config: error?.config || {
              url: "/api/v1/reward/GenVerifyQRCode",
              method: "POST",
              methods: "POST",
              data: ""
            }
          },
          action: { id: 3, action: "getVerificationCode API request failed" }
        });
        throw error;
      }
    },
    async copyCode() {
      if (!this.qrValue) return;
      try {
        if (navigator?.clipboard?.writeText) {
          await navigator.clipboard.writeText(String(this.qrValue));
        } else {
          const textarea = document.createElement("textarea");
          textarea.value = String(this.qrValue);
          textarea.style.position = "fixed";
          textarea.style.opacity = "0";
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand("copy");
          document.body.removeChild(textarea);
        }
        this.emitter.emit("showToast", {
          message: this.$t("copy_success") || "คัดลอกสำเร็จ",
          type: "success",
          duration: 3000
        });
      } catch (error) {
        console.log("copyCode", error);
      }
    },
    dateFormat(value, format) {
      if (!value) return "-";
      return this.$dateFormat(value, format);
    }
  }
};
</script>

<style lang="scss" scoped>
.code-verify-v2__status {
  display: flex;
  justify-content: center;
  padding: 18px 0 20px;
}

.code-verify-v2__status > div {
  box-sizing: content-box;
  width: 42px;
  height: 42px;
  padding: 24px;
  border-radius: 50%;
  background: rgba(196, 0, 45, 0.1);
  color: var(--button-color);
}
.code-verify-icon {
  width: 42px;
  height: 42px;
  flex-shrink: 0;
  background-color: var(--primary-color);
  -webkit-mask-image: var(--icon-url);
  mask-image: var(--icon-url);
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-size: contain;
  mask-size: contain;
}
// .code-verify-v2__status div.icon {
//   background: var(--button-color);
// }
.code-verify-v2__actions {
  padding-top: 18px;
}

.code-verify-v2__actions :deep(.btn) {
  min-height: 58px;
}
</style>
